import React from 'react';
import { Link } from 'react-router-dom';

type AccordionItemProps = {
  title: string;
  description: string;
  imageUrl: string;
  linkUrl: string;
  status: string;
};

const AccordionItemChecklist: React.FC<AccordionItemProps> = ({ title, description, imageUrl, linkUrl, status }) => {
  return (
    <Link to={linkUrl} className="checklist-link">
      <li className="checklist-item">
        <div className="checklist-image">
          <img
            width="400"
            height="360"
            src={imageUrl}
            className="img-fluid wp-post-image"
            alt={title}
          />
        </div>
        <div className="checklist-body">
          <h2>{title}</h2>
          <p className="size-large">{description}</p>
        </div>
        <div className="checklist-status">
          <span className="pill">{status}</span>
        </div>
      </li>
    </Link>
  );
};

export default AccordionItemChecklist;
